import axiosInstance from "../api";
import {
  GET_COMPANY_SEARCH_EXPERT,
  GET_TEAM_FILE_BYID,
  GET_TEAM_FILE_FOLDER,
  GET_TEAM_MEMBER,
  GET_TEAM_MILESTONE,
  GET_TEAM_OVERVIEW,
  GET_TEAM_PROJECT,
  GET_TEAM_SEARCH_EXPERT,
  GET_TEAM_TASK,
} from "../constants";
import { urtoast } from "../../Components/Layouts/CustomPopup/eventEmitter";

export const postTeam = (data) => async (dispatch) => {
  try {
    const response = await axiosInstance.post("team", data);
    if (response?.data?.status) {
      dispatch(getTeamProject());
      urtoast(response?.data?.response?.message, 1);
      // window.location.reload()
      return response;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};

export const postFolderforTeam = (data) => async (dispatch) => {
  try {
    const response = await axiosInstance.post("team", data);
    if (response?.data?.status) {
      dispatch(getTeamFilesFolderList());
      urtoast(response?.data?.response?.message, 1);
      // window.location.reload()
      return response;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};

export const postFileforTeam = (data) => async (dispatch) => {
  try {
    const response = await axiosInstance.post("team", data);
    if (response?.data?.status) {
      dispatch(getTeamFilesListbyid(data?.team_folder_id, "", ""));
      urtoast(response?.data?.response?.message, 1);
      // window.location.reload()
      return response;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};

export const postTeamMilestone = (data) => async (dispatch) => {
  try {
    const response = await axiosInstance.post("team", data);
    if (response?.data?.status) {
      dispatch(getTeamTask(data?.team_project_id, '', ''));
      urtoast(response?.data?.response?.message, 1);
      // window.location.reload()
      return response;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};

export const joinRequestTeam = (data) => async (dispatch) => {
  try {
    const response = await axiosInstance.post("team", data);
    if (response?.data?.status) {
      dispatch(getTeamProject());
      urtoast(response?.data?.response?.message, 1);
      return response;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};

export const UpdateTeam = (data, navigate) => async (dispatch) => {
  try {
    const response = await axiosInstance.put("team/update", data);
    if (response?.data?.status) {
      urtoast(response?.data?.response?.message, 1);
      return response;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};

export const UpdateTask = (data) => async (dispatch) => {
  try {
    const response = await axiosInstance.put("team/update", data);
    if (response?.data?.status) {
      dispatch(getTeamTask(data?.team_project_id, '', ''));
      console.log(data, data?.reload, 'data?.reload');
      
      if (data?.reload) {
        window.location.reload()
      }
      urtoast(response?.data?.response?.message, 1);
      return response;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};

export const getTeamProject = (type) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`team?type=1`);
    if (response?.data?.status) {
      dispatch({
        type: GET_TEAM_PROJECT,
        getteamprojects: response?.data?.response,
      });
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};

export const getTeamMilestone = (id) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(
      `team?type=3&team_project_id=${id}`,
    );
    if (response?.data?.status) {
      dispatch({
        type: GET_TEAM_MILESTONE,
        getteammilestones: response?.data?.response,
      });
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};

export const getTeamTask = (id, sort, title) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(
      `team?type=3&team_project_id=${id}&sort=${sort}&title=${title}`,
    );
    if (response?.data?.status) {
      dispatch({ type: GET_TEAM_TASK, getteamtasks: response?.data?.response });
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};

export const getTeamOverview = (type) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`team?type=4`);
    if (response?.data?.status) {
      dispatch({
        type: GET_TEAM_OVERVIEW,
        getteamoverviews: response?.data?.response,
      });
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};

export const getTeamMembers = (sortoption, searchtext) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(
      `team?type=5&sort=${sortoption ?? ""}&title=${searchtext ?? ""}`,
    );
    if (response?.data?.status) {
      dispatch({
        type: GET_TEAM_MEMBER,
        getteammemberss: response?.data?.response,
      });
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};

export const getTeamSearchExpert = (data) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(
      `team?type=6&title=${data.searchtext}&index=${data.index}&size=10`,
    );
    if (response?.data?.status) {
      dispatch({
        type: GET_TEAM_SEARCH_EXPERT,
        getteamsearchexperts: response?.data,
      });
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};

export const getComapnySearchExpert = (data) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(
      `team?type=9&title=${data.searchtext}&index=${data.index}&size=12`,
    );
    if (response?.data?.status) {
      dispatch({
        type: GET_COMPANY_SEARCH_EXPERT,
        getcompanysearchexperts: response?.data
      });
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};

export const getTeamFilesFolderList =
  (sortoption, searchtext) => async (dispatch) => {
    try {
      const response = await axiosInstance.get(
        `team?type=7&sort=${sortoption ?? ""}&title=${searchtext ?? ""}`,
      );
      if (response?.data?.status) {
        dispatch({
          type: GET_TEAM_FILE_FOLDER,
          getteamfilefolderlist: response?.data?.response,
        });
        return;
      }
      urtoast(response?.data?.response?.message, 2);
    } catch (err) {
      //urtoast(err.message, 2);
    }
  };

export const getTeamFilesListbyid =
  (id, sortoption, searchtext) => async (dispatch) => {
    try {
      const response = await axiosInstance.get(
        `team?team_folder_id=${id}&type=11&sort=${sortoption}&title=${searchtext}`,
      );
      if (response?.data?.status) {
        dispatch({
          type: GET_TEAM_FILE_BYID,
          getteamfilelistbyid: response?.data?.response,
        });
        return;
      }
      urtoast(response?.data?.response?.message, 2);
    } catch (err) {
      //urtoast(err.message, 2);
    }
  };

export const LeaveComapany = (data) => async (dispatch) => {
  try {
    const response = await axiosInstance.put("team/update", data);
    
    if (response?.data?.status) {
      urtoast(response?.data?.response?.message, 1);
      window.location.reload();
      return { success: true, response };
    }
    
   
    return { success: false, message: response?.data?.response?.message };
    
  } catch (err) {
    return { success: false, message: err.message || "An error occurred" };
  }
};
